import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Sprout } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role === "customer") { toast.error("এটি অ্যাডমিন অ্যাকাউন্ট নয়"); setLoading(false); return; }
      toast.success("স্বাগতম!");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#14281D] p-4 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "url(https://images.unsplash.com/photo-1558388556-2261d4cc1938?w=1200)", backgroundSize: "cover" }} />
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md p-8">
        <div className="text-center mb-6">
          <div className="w-16 h-16 rounded-2xl bg-[#1E3A2B] flex items-center justify-center text-[#CA8A04] mx-auto mb-3"><Sprout size={32} /></div>
          <h1 className="text-2xl font-bold text-[#1E3A2B]">অ্যাডমিন প্যানেল</h1>
          <p className="text-stone-500 text-sm mt-1">M.D.Rice Mill ম্যানেজমেন্ট</p>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <input type="email" placeholder="ইমেইল" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full h-12 px-4 rounded-xl border border-stone-300" data-testid="admin-email" required />
          <input type="password" placeholder="পাসওয়ার্ড" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full h-12 px-4 rounded-xl border border-stone-300" data-testid="admin-password" required />
          <button type="submit" disabled={loading} className="w-full bg-[#CA8A04] hover:bg-[#A16207] text-white font-medium h-12 rounded-xl flex items-center justify-center gap-2 disabled:opacity-50" data-testid="admin-login-submit">
            <Lock size={16} /> {loading ? "প্রবেশ করছি..." : "প্রবেশ করুন"}
          </button>
        </form>
      </div>
    </div>
  );
}
